import http from '@root/utils/axios/admin';
const state = {
    token: localStorage.getItem('admin/user-token') || '',
    errors: {},
    authUser: {}
};
const getters = {
    authToken(state) {
        return state.token;
    },
    canHandlePermission: (state) => (targetPermissions) => {
        let authPermissions = JSON.parse(JSON.stringify(state.authUser)).permissions;
        if (typeof authPermissions !== "undefined") {
            const exists = authPermissions.some(obj => {
                return targetPermissions.some(value => obj.name === value);
            });
            return exists;
        }
        return false;
    },
};

const actions = {
    /**
     * Authenticate Request.
     */
    login({ commit }, { email, password }) {

        return new Promise((resolve, reject) => {

            http.post('user/login', {
                    email,
                    password
                })
                .then(response => {
                    commit('authSuccess', response.data.access_token);

                    resolve(response);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        commit('authError', error.response.data);
                    }

                    reject(error);
                });
        });
    },

    /**
     * Auth logout.
     */
    authLogout({ commit }) {

        return new Promise((resolve, reject) => {

            http.post('/user/logout').then((response) => {
                    commit('authLogout');
                    resolve(response);
                })
                .catch((error) => {
                    commit('authLogout');
                    reject(error);
                });
        });
    },

    fetchAuth({ commit }) {
        return new Promise((resolve, reject) => {
            http.get('/user/get-auth').then((response) => {
                commit('setAuthUser', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

};
const mutations = {
    authSuccess(state, token) {
        localStorage.setItem('admin/user-token', token);
        state.token = token;
        state.errors = {};
    },
    authLogout(state) {
        localStorage.removeItem('admin/user-token');
        state.token = '';
    },
    authError(state, errors) {
        localStorage.removeItem('admin/user-token');
        state.errors = errors.errors;
        state.token = '';
    },
    setAuthUser(state, data) {

        state.authUser = data.data;
    },

    loginCleanErrors(state) {
        state.errors = {};
    },
};

export default {
    state,
    actions,
    getters,
    mutations
}